import moment from 'moment';
import { format } from 'date-fns';

export function getDiaDaSemana(date: Date): string {
    const dia = date.getDay();
    const semana: string[] = [];
    semana[0] = 'Domingo';
    semana[1] = 'Segunda-Feira';
    semana[2] = 'Terça-Feira';
    semana[3] = 'Quarta-Feira';
    semana[4] = 'Quinta-Feira';
    semana[5] = 'Sexta-Feira';
    semana[6] = 'Sábado';
    return semana[dia];
}

//Explicação do uso da função format:
//https://github.com/date-fns/date-fns/blob/main/docs/unicodeTokens.md

export function getHoraMinuto(data: Date): string {
    return format(data, 'HH:mm');
}

export function formatDDMMYYYY(data: Date): string {
    return format(data, 'dd/MM/yyyy');
}

export function formatDDMMYYYY_HHmmss(data: Date): string {
    return format(data, 'dd/MM/yyyy HH:mm:ss');
}

export function formatMMDDYYYY_HHmmss(data: Date): string {
    return format(data, 'MM/dd/yyyy HH:mm:ss');
}

export function formatYYYYMMDD_HHmmss(data: Date): string {
    return format(data, 'yyyy/MM/dd HH:mm:ss');
}

export function formatYYYYMMDD(data: Date): string {
    return format(data, 'yyyy/MM/dd');
}

export function inicioDoDia(data: string): string {
    const date: Date = new Date(data);
    date.setHours(0, 0, 0, 0);
    return formatYYYYMMDD_HHmmss(date);
}

export function finalDoDia(data: string): string {
    const date: Date = new Date(data);
    date.setHours(23, 59, 59, 999);
    return formatYYYYMMDD_HHmmss(date);
}

export function isFimDeSemana(data: Date) {
    const dia = data.getDay();
    return dia == 6 || dia == 0;
}

export function isMesmaData(data1: Date, data2: Date): boolean {
    const dataOne: Date = new Date(data1);
    const dataTwo: Date = new Date(data2);
    dataOne.setHours(0, 0, 0, 0);
    dataTwo.setHours(0, 0, 0, 0);
    return dataOne.getTime() === dataTwo.getTime();
}

export function isData1MaiorIgualData2(data1: Date, data2: Date): boolean {
    const dataOne: Date = new Date(data1);
    const dataTwo: Date = new Date(data2);
    dataOne.setHours(0, 0, 0, 0);
    dataTwo.setHours(0, 0, 0, 0);
    return dataOne.getTime() >= dataTwo.getTime();
}

export function inverterMesDiaFormatoBR(data: string): string {
    if (data) {
        const partes: string[] = data.split('/');
        return partes[1].concat('/').concat(partes[0]).concat('/').concat(partes[2]);
    } else {
        return data;
    }
}

export function inverteParaFormatoYYYYMMDD(data: string): string {
    if (data) {
        const partes: string[] = data.split('/');
        return partes[2].concat('/').concat(partes[1]).concat('/').concat(partes[0]);
    } else {
        return data;
    }
}

export function diferencaDiasEntreDatas(data1: Date, data2: Date): number {
    const dateOne = moment(data1);
    const dateTwo = moment(data2);
    return moment.duration(dateTwo.diff(dateOne)).asDays();
}

export function getDate(offsetYear: number, offsetMonth: number, offsetDay: number) {
    const date = new Date(),
        d = date.getDate(),
        m = date.getMonth(),
        y = date.getFullYear();
    return new Date(y + offsetYear, m + offsetMonth, d + offsetDay);
}

export function getDataAtual(): string {
    const hoje = new Date();
    return formatDDMMYYYY(hoje);
}

export function getDateDDMMYYYY(value: string): Date {
    if (value) {
        const ano = Number(value.split('/')[2]);
        const mes = Number(value.split('/')[1]) - 1;
        const dia = Number(value.split('/')[0]);
        const hor = 0;
        const min = 0;
        const seg = 0;

        return new Date(ano, mes, dia, hor, min, seg, 0);
    } else {
        return null;
    }
}

export function getValidDateDDMMYYYY(value: string): Date | null {
    const partes = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    if (!partes) {
        return null;
    }

    const dia = Number(partes[1]);
    const mes = Number(partes[2]);
    const ano = Number(partes[3]);

    return isValidDate(ano, mes, dia) ? new Date(ano, mes - 1, dia) : null;
}

export function dataValidaRegExp(data: string): boolean {
    const expressao = new RegExp(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/);
    return expressao.test(data);
}

//Transforma uma data no formato YYYY-MM-DD para Date
export function getDateFromYYYYMMDD(value: string): Date {
    if (value) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    } else {
        return null;
    }
}

export function formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function isValidDate(year: number, month: number, day: number) {
    const date = new Date(year, month - 1, day);
    const isValid = date.getFullYear() == year && date.getMonth() == month - 1 && date.getDate() == day;
    return isValid;
}
